"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeritextBinding = void 0;
const invokeFirstOnly_1 = require("@jsonjoy.com/util/lib/invokeFirstOnly");
class PeritextBinding {
    constructor(peritext, facade) {
        this.peritext = peritext;
        this.facade = facade;
        this.race = (0, invokeFirstOnly_1.invokeFirstOnly)();
        // ----------------------------------------------------- Model-to-Editor sync
        this.onModelChange = (event) => {
            return this.race(() => {
                this.syncFromModel();
            });
        };
        // ----------------------------------------------------- Editor-to-Model sync
        this.onEditorChange = (operation) => {
            return this.race(() => {
                return this.syncFromEditor(operation);
            });
        };
        // ------------------------------------------------------------------ Binding
        this._s0 = null;
        this._s1 = null;
        /** Last known selection before a local change, if any. */
        this._selection = undefined;
        this.bind = () => {
            this.syncFromModel();
            const editor = this.facade;
            editor.onchange = this.onEditorChange;
            const peritext = this.peritext();
            this._s0 = peritext.onSubtreeChange(this.onModelChange);
            const facade = this.facade;
            if (facade.getSelection) {
                const storeSelection = () => {
                    this._selection = facade.getSelection?.(peritext);
                };
                this._s1 = peritext.api.onBeforeChange.listen(storeSelection);
            }
        };
        this.unbind = () => {
            this._s0?.();
            this._s1?.();
            this.facade.dispose?.();
        };
    }
    syncFromModel() {
        // console.log('syncFromModel');
        const peritext = this.peritext();
        const facade = this.facade;
        const txt = peritext.txt;
        txt.refresh();
        const fragment = txt.blocks;
        facade.set(fragment);
        const selection = this._selection;
        if (selection)
            facade.setSelection?.(peritext, selection[0], selection[1]);
    }
    syncFromEditor(operation) {
        const peritext = this.peritext;
        const txt = peritext().txt;
        if (operation) {
            // console.log('syncFromEditor (fast)', operation);
            const [pos, del, ins] = operation;
            if (del > 0)
                txt.delAt(pos, del);
            if (ins)
                txt.insAt(pos, ins);
        }
        else {
            // console.log('syncFromEditor (full merge)');
            const viewRange = this.facade.get();
            txt.editor.merge(viewRange);
        }
        txt.refresh();
        return peritext;
    }
}
exports.PeritextBinding = PeritextBinding;
PeritextBinding.bind = (peritext, editor) => {
    const binding = new PeritextBinding(peritext, editor);
    binding.bind();
    return binding.unbind;
};
